export const CONTACTMETHODS = {
    EMAIL: 'Email',
    TEXT: 'Text',
    EMAIL_TEXT:'Email & Text'
};